import { css } from "styled-components";

export const tabStyle = css`
    .dit-components-tab-container {
        box-shadow: var(--dit-layout-shadow-card--map);
    }

    .dit-components-tab a > span.dit-components-tab-content {
        color: var(--dit-layout-color-tab--map);
    }
`;
